import React from 'react';

function DividerText({ text }) {
  return (
    <div className="divider-text">
      <span>{text}</span>
    </div>
  );
}

export default DividerText;
